module.exports = __webpack_public_path__ + "img/07.fc21c99b.png";